import { FF_KEAP_SMS_BROADCAST } from '@/shared/constants/featureFlag.constants';

export default {
    showSmsBroadcast(state, getters, rootState, rootGetters) {
        return rootGetters['automatedSms/showSmsMarketing']
            && rootGetters['auth/hasSmsBroadcastFeature']
            && rootState.featureFlags[FF_KEAP_SMS_BROADCAST];
    },
};
